import React, {useState} from "react";
import Burger from '../Hamburger.js'
import MobileNavBar from '../MobileNavBar.js'
import '../Desktop.css'

import Book from '../../Images/Design/PenguinBooks/Radiant.jpg'
import Jacket from '../../Images/Design/PenguinBooks/Radiant_jacket.jpg'



function Radiant(){
	const [open, setOpen] = useState(false);

	return(
		<div class="page">
		    <div class="designContentPageBook">
		    	<div className="mobileNav">
					<Burger open={open} setOpen={setOpen}/>
					<MobileNavBar open={open} setOpen={setOpen}/>
				</div>
		        <div class="contentHMH">
		            <img class="contentImage" src={Book} />
		            <p class="contentTextHMHTitle">Radiant</p>
		            <p class="contentTextHMH">Penguin Young Readers</p>
		            <p class="contentTextHMH ItalicText" >Art direction, design</p>
		            <br />
		            <p class="contentTextHMH2 ItalicText" >Illustration by Erin K. Robinson</p>
		        </div>
				<br />
				<img class="contentImage" src={Jacket} />
		    </div>
		</div>
	)
}

export default Radiant